/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentDocumentListResponse = {
    type: 'array',
    contains: {
        type: 'DepartmentDocumentResponse',
    },
};